import React, { Component } from 'react';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import { Navigate } from 'react-router-dom';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import Multi from './MultiSearchAll';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import StoreTable from './manageUserStore/StoreTable';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LZString from 'lz-string';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class ManageUserStores extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');

    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));

    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let userID = user['userId'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: 'Manage User Stores',
      data: [],
      alert: '',
      incType: '',

      storeValue: null,
      storeSelected: false,
      closure: '',
      stores,
      wareHouses,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      submittedBy: '',
      user: menu,
      pageAllowed: false,
      user_id: '',
      userID: userID,
      userName: null,
      surname: null,
      userSelected: false,
      storeData: [],
      multiSearch: '',
      dataVisible: false,
      allStores: [],
      someRV: false,
    };
  }

  handleStoreValue = (e) => {
    this.setState({
      storeValue: e.target.value,
      loading: true,
      user_id: '',
      userName: '',
    });

    ApiGateWay.PostEmp(
      this.state.apiInterface +
        '/fetchEmpInfo?storeId=' +
        e.target.value +
        '&zomc=1'
    )
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        this.setState({
          codeJson: response,
          loading: false,
          dataVisible: false,
          storeSelected: true,
          userSelected: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  handleUserChange = (e) => {
    let sumSt = e.target.value;
    let reSt = sumSt.split(' ');

    let multiSearchData = JSON.parse(localStorage.getItem('multisearchall'));

    let storesForMultiSearch = this.state.allStores;
    storesForMultiSearch.storeInfo.map((value) => {
      value.activeFlag = 0;

      JSON.parse(multiSearchData.data).map((val) => {
        if (val.label === value.storeName) {
          value.activeFlag = 0;
        }
      });
    });
    this.setState({
      user_id: reSt[0],
      userName: reSt[1],
      allStores: storesForMultiSearch,
      loading: true,
      userSelected: true,
    });

    ApiGateWay.Post(this.state.apiInterface + '/fetchUserStores', {
      userId: reSt[0],
    })
      .then((response) => response.json())
      .then((response) => {
        let storesForMultiSearch = response;
        storesForMultiSearch.stores.map((value) => {
          value.activeFlag = 1;
        });
        this.setState({
          storeData: response,
          dataVisible: true,
          someRV: true,
          loading: false,
        });

        // alert(JSON.stringify(this.state.storeData));
      })

      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };

  updateUserStore = () => {
    if (this.state.storeValue === '' || this.state.storeValue === null) {
      toast.error('Please select the store', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.state.userName === '' || this.state.userName === null) {
      toast.error('Please select the user', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({
        loading: true,
      });

      let multiSearchData = JSON.parse(localStorage.getItem('multisearchall'));

      let storesForMultiSearch = this.state.allStores;
      storesForMultiSearch.storeInfo.map((value) => {
        value.activeFlag = 0;

        JSON.parse(multiSearchData.data).map((val) => {
          if (val.label === value.storeName) {
            value.activeFlag = 1;
          }
        });
      });

      let storeIds = JSON.parse(multiSearchData.data).map((val) => val.value);

      //const user = JSON.parse(Cookie.get('currentUser'));
      let data = {
        storeIds: JSON.parse(multiSearchData.data).map((val) => val.value),
        userId: this.state.userID,
      };

      ApiGateWay.Post(
        this.state.apiInterface +
          '/saveEmployeeStores?storeIds=' +
          storeIds +
          '&userId=' +
          this.state.user_id
      )
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            this.setState({
              multiSearch: data,
              someRV: false,
              allStores: storesForMultiSearch,
              loading: true,
            });
          }

          ApiGateWay.Post(this.state.apiInterface + '/fetchUserStores', {
            userId: this.state.user_id,
          })
            .then((response) => response.json())
            .then((response) => {
              this.setState({
                storeData: response,
                dataVisible: true,
                loading: false,
              });
            })

            .catch((error) => {
              this.setState({
                loading: false,
                modalOpen: true,
                message: 'Unable to retrieve the data. Please try again later',
              });
            });
          //this.handleUserChange(this.state.user_id);
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  };

  componentDidMount() {
    console.clear();
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? val.featureAccess
          ? val.featureAccess.map((child1, ind) =>
              child1.featureName == 'Manage User Stores'
                ? (pageAllow = true)
                : ''
            )
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });

      ApiGateWay.Get(this.state.apiInterface + '/loadStoreInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            allStores: response,
            visible: true,
            loading: false,
          });
          Cookie.set('storesAll', response, {
            secure: true,
            sameSite: 'strict',
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });

      ApiGateWay.PostEmp(this.state.apiInterface + '/fetchEmpInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            submittedByCodeJson: response,
            visible: true,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
    // this.loadStoreData(0);
  }
  render() {
    const { loading, modalOpen, pageAllowed, message } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'Manage User Stores'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
     
          <Navigate to="/pageNotAllowed" state={{ id:'Manage User Stores' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row'>
                  <div className='col-md-3'>
                    <ToastContainer
                      position='top-right'
                      autoClose={3000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      className=''
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    />
                    <form
                      style={{ background: 'none', padding: 'none' }}
                      //role='form'
                    >
                      <div className='form-group '>
                        <select
                          className='form-control EvacInput'
                          value={this.state.storeValue}
                          onChange={this.handleStoreValue}
                        >
                          <option value='' selected disabled>
                            Select a store
                          </option>
                          <option value='0'>Non Store User</option>
                          {this.state.allStores.storeInfo
                            ? this.state.allStores.storeInfo.map((val) => (
                                <option key={val.storeId} value={val.storeId}>
                                  {val.storeName}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>
                    </form>
                  </div>
                </div>
                <div className='row'>
                  <form
                    className='form'
                    style={{ background: 'none', padding: '0% 0%' }}
                  >
                    <div className='col-md-3'>
                      <form style={{ background: 'none', padding: 'none' }}>
                        <div className='form-group'>
                          <select
                            className='form-control EvacInput'
                            onChange={this.handleUserChange}
                            value={this.state.user_id}
                            style={{
                              textTransform: 'capitalize',
                              marginBottom: '25px',
                            }}
                          >
                            <option disabled selected value=''>
                              Select User
                            </option>
                            {this.state.storeSelected &&
                            this.state.codeJson.empInfos
                              ? this.state.codeJson.empInfos.map((val) => (
                                  <option
                                    key={val.user_id}
                                    value={val.user_id}
                                    style={{ textTransform: 'capitalize' }}
                                  >
                                    {val.givenName} {val.surname}
                                  </option>
                                ))
                              : null}
                          </select>
                        </div>
                      </form>
                    </div>
                  </form>
                </div>
                <div className='row'>
                  <div className='col-md-3     '>
                    <form style={{ background: 'none', padding: 'none' }}>
                      <div className='autocomplete-wrapper EvacInput'>
                        <Multi
                          name='allStores'
                          allStore={this.state.allStores}
                          someRV={this.state.someRV}
                          storeData={this.state.storeData}
                          userSelected={this.state.userSelected}
                        />
                      </div>
                    </form>
                  </div>
                  <div
                    className='col-md-1 col-lg-1 col-sm-1'
                    style={{ margin: '8px' }}
                  >
                    <form style={{ background: 'none', padding: 'none' }}>
                      <button
                        type='button'
                        onClick={this.updateUserStore}
                        className='btn btn-secondary deca-btn-yellow'
                      >
                        SUBMIT
                      </button>
                    </form>
                  </div>
                </div>
                <br /> <br />
                <div className='row'>
                  <div className='col-md-12'>
                    <StoreTable
                      storeData={
                        this.state.dataVisible ? this.state.storeData : ''
                      }
                    />
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default ManageUserStores;
